import React from 'react';
import { translate  } from 'react-i18next';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';
import {observer} from 'mobx-react';
import TextField from '../Components/Form/TextField';

@observer
class AddressSection extends React.Component {
  render() {
    const { t, booking: { address } } = this.props;

    return (
    	<div>
        <Row>
        	<Col xs="12" lg="5">
            <TextField
              required
              label={t('Straße')}
              value={address.street || ''}
              onChange={(e) => address.street = e.target.value}
              placeholder={t('Straße')}
            />
          </Col>

          <Col xs="12" lg="4">
            <TextField
              required
              label={t('Stadt')}
              value={address.city || ''}
              onChange={(e) => address.city = e.target.value}
              placeholder={t('Stadt')}
            />
          </Col>

          <Col xs="12" lg="3">
            <TextField
              required
              label={t('Postleitzahl')}
              value={address.zip_code || ''}
              onChange={(e) => address.zip_code = e.target.value.substr(0, 10)}
              placeholder={t('Postleitzahl')}
            />
          </Col>
        </Row>

        <Row>
          <Col xs="12">
            <TextField
              label={t('State')}
              value={address.state || ''}
              onChange={(e) => address.state = e.target.value.substr(0, 50)}
              placeholder={t('State')}
            />
          </Col>

          <Col xs="12">
            <TextField
              required
              label={t('Land')}
              value={address.country || ''}
              onChange={(e) => address.country = e.target.value}
              placeholder={t('Land')}
            />
          </Col>
        </Row>
        <div className='separator mb-2'></div>
        <Row>
          <Col><small>{t('bookingForm.requiredMessage')}</small></Col>
        </Row>
      </div>
    );
  }
};

export default translate ()(AddressSection);



// WEBPACK FOOTER //
// ./src/App/Checkout/AddressSection.js